// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"127f29ab","455":"295de795","977":"ae415729"}[chunkId] + ".chunk.js";
};